<div class="calibration-icon-container">
  <mydocma-custom-mat-icon
    class="calibration-map-pin-icon"
    [iconName]="iconName"
  >
  </mydocma-custom-mat-icon>
  <span class="calibration-icon-number" *ngIf="pinNumber">{{ pinNumber }}</span>
</div>
